import { PropTypes as MobXPropTypes } from 'mobx-react';
import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { BedOptionViewModel } from 'models';
import * as PropTypes from 'prop-types';

import { UitkCardTextSegment } from 'uitk-react-cards';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

export interface BeddingOptionsProps {
  options?: BedOptionViewModel[];
}

export class BeddingOptions extends React.PureComponent<BeddingOptionsProps> {
  public static propTypes = {
    options: MobXPropTypes.arrayOrObservableArrayOf(
      PropTypes.shape({
        icon: PropTypes.string,
        name: PropTypes.string,
      })
    ),
  };

  public render() {
    const { options } = this.props;

    if (!options || options.length === 0) {
      return null;
    }

    return (
      <UitkCardTextSegment data-stid="room-info-bedding-options">
        <h3 className="uitk-type-heading-400 all-b-margin-three" data-stid="room-info-bedding-options-title">
          <LocalizedText message="hotels.infosite.roomInfoDialog.bedDetails.title.sentenceCase" />
        </h3>
        <div className="uitk-cell bedding-options l-cell-1-6 xl-cell-1-6">
          <div className="pwa-theme--grey-700">
            <UitkIcon className="all-r-padding-one all-b-margin-one" name="bed" size={UitkIconSize.SMALL} />
            <span data-stid="content-room-beddingoptions-inline">
              {options.map((option, index) => (
                <span key={`bedding-${option.name}-${index}`}>
                  {index > 0 && (
                    <span className="all-l-padding-one">
                      <LocalizedText message="hotels.infosite.ratePlan.room.multipleOptions.or.text" />
                    </span>
                  )}
                  <span data-stid="content-room-beddingoptions"> {option.name.toLowerCase()}</span>
                </span>
              ))}
            </span>
          </div>
        </div>
      </UitkCardTextSegment>
    );
  }
}
